<script lang="ts">
    import {guiCreatorDataStore} from '../../stores/guiCreatorData';

    export let selectedPageName;
    let elementsToDeleteCount = 0;
    $: {
        const selectedPage = guiCreatorDataStore.get().pages[selectedPageName];
        if (selectedPage) {
            elementsToDeleteCount = Object.keys(selectedPage).length;

        }
    }

    function deletePage(page) {
        guiCreatorDataStore.deletePage(page);
    }
</script>

<input type="checkbox" id="page-deletion-confirmation" class="modal-toggle"/>
<div class="modal">
    <div class="modal-box">
        <h3 class="font-bold text-lg">Confirm page deletion of page {selectedPageName}</h3>
        <p class="py-4">Do you want to really delete the page {selectedPageName} with {elementsToDeleteCount}
            element{elementsToDeleteCount > 0 ? 's' : ''}</p>
        <div class="modal-action" id="page-deletion-confirmation-btn">
            <label for="page-deletion-confirmation" class="btn btn-error" on:click={() => deletePage(selectedPageName)}>Delete</label>
        </div>
    </div>
</div>
